import api from '@/libs/axios'
import { cleanEntityToSend } from '../../utils/form'
import Vue from 'vue'
import ToastificationContent from '@/components/toastification/ToastificationContent.vue'
import { capitalize } from '@/utils/filter'
import i18n from '@/libs/i18n'
import store from '@/store'

export default {
  getBankOperations ({ commit }) {
    return new Promise((resolve, reject) => {
      api.get('/bankOperations')
        .then(response => {
          commit('SET_BANKOPERATIONS', response.data)
          resolve(response)
        })
        .catch(err => {
          console.log('Error', err)
          reject(err)
        })
    })
  },
  async addBankOperation ({ commit, state }, bankOperation) {
    return await cleanEntityToSend(bankOperation, state.params)
      .then(async clonedEntityToSend => {
        return new Promise((resolve, reject) => {
          api.post('/bankOperations', clonedEntityToSend)
            .then(response => {
              commit('ADD_BANKOPERATION', response.data)

              store.commit('bankAccount/ADD_BANKOPERATION', response.data)

              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The bankOperation has been ', { crud: i18n.t('createdE') }),
                  variant: 'success'
                },
              })

              resolve(response)
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  async updateBankOperation ({ commit, state }, bankOperation) {
    return await cleanEntityToSend(bankOperation, state.params)
      .then(async clonedEntityToSend => {

        return new Promise((resolve, reject) => {
          api.put('/bankOperations/' + bankOperation.id, clonedEntityToSend)
            .then(response => {
              commit('UPDATE_BANKOPERATION', response.data)

              store.commit("bankAccount/UPDATE_BANKOPERATION", response.data)

              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The bankOperation has been ', { crud: i18n.t('editedE') }),
                  variant: 'success'
                },
              })

              resolve(response)
              // resolve(JSON.parse(JSON.stringify(response)))
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  removeBankOperation ({ commit }, bankOperation) {
    return new Promise((resolve, reject) => {
      api.delete('/bankOperations/' + bankOperation.id)
        .then(response => {
          commit('REMOVE_BANKOPERATION', bankOperation)

          store.commit("bankAccount/REMOVE_BANKOPERATION", bankOperation)

          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: capitalize(i18n.t('success')),
              icon: 'check',
              text: i18n.t('The bankOperation has been ', { crud: i18n.t('removed') }),
              variant: 'success'
            },
          })

          resolve(response)
        })
        .catch(error => {
          console.log('Error', error)
          reject(error)
        })
    })
  },

}